import React from "react";
import { useHistory } from "react-router-dom";
import NoResultSvg from "./no-result.svg";
import { NoResultWrapper, ImageWrapper, ButtonWrapper } from "./NoResult.style";
import Button from "../Button/Button";
import { ArrowPrev } from "../AllSvgIcon";
import { SearchContext } from "../../contexts/search/search.context";
import { FormattedMessage } from "react-intl";
import SidebarFilter from "../SideBarFilter/SideBarfilter";
import { FilterDiv, FilterWrapper } from "../../containers/Products/Products.style";

const NoResultFound = ({ id, defaultMessage = "Sorry, No product found :(", props, toggleFilter, isFilterModal, isBrandFilter, setSelectedBrands, GetSub }) => {
  const { searchdispatch } = React.useContext(SearchContext);

  function onClickButton() {
    searchdispatch({
      type: "RESET",
    });
    window.location.href = "/";
    // window.location.reload();
  }
  return (
    <NoResultWrapper id={id}>
      <h3>
        <FormattedMessage
          id="noResultFound"
          defaultMessage={defaultMessage}
        />
      </h3>

      <ImageWrapper>
        <img src={NoResultSvg} alt="No Result" />
      </ImageWrapper>

      {/* <ButtonWrapper>
        <div onClick={onClickButton}>
          <Button title="Go Back" />
        </div>
      </ButtonWrapper> */}
      <FilterWrapper>
        <div className={`bg_blur ${isFilterModal ? 'show' : ''}`} onClick={() => toggleFilter()} ></div>
        <FilterDiv >
          <div className={`modal ${isFilterModal ? 'show animate' : ''} row`}>
            {props?.cartType !== 'express' ? (
              <div style={{ padding: "0px" }} className="col-sm-eight">
                <SidebarFilter 
                  brands={props?.filterBrands}
                  GetSub={GetSub}
                  products={props.products}
                  setSelectedBrands={setSelectedBrands}
                  isModal={isBrandFilter}
                  ModalOpen={isFilterModal}
                  showModal={toggleFilter} 
                  loading={props?.loading}
                />
              </div>
            ) : window.screen.width < 700 && props?.cartType !== 'express' ? (
                <SidebarFilter
                  brands={props?.filterBrands}
                  GetSub={GetSub}
                  products={props.products}
                  setSelectedBrands={setSelectedBrands}
                  isModal={isBrandFilter}
                  ModalOpen={isFilterModal}
                  showModal={toggleFilter} 
                  loading={props?.loading}
                />
            ) : props?.cartType !== 'express' ? <div className="_1q59bef"></div> : null
            }
          </div>
        </FilterDiv>
      </FilterWrapper>
    </NoResultWrapper>
  );
};

export default NoResultFound;
